var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87368 0C3.95752 0 0 3.95752 0 8.87368V37.1263C0 42.0425 3.95752 46 8.87368 46H37.1263C42.0425 46 46 42.0425 46 37.1263V8.87368C46 3.95752 42.0425 0 37.1263 0H8.87368ZM20.0071 6.50468H24.5669V14.6093H32.177V19.6435H24.5669V27.866C24.5669 29.7245 24.6656 30.9185 24.863 31.4468C25.0593 31.9741 25.4264 32.3951 25.9613 32.7104C26.6707 33.1356 27.481 33.3486 28.3949 33.3486C30.0177 33.3486 31.633 32.8201 33.2393 31.7645V36.8216C31.8687 37.4669 30.629 37.9218 29.5191 38.1815C28.4079 38.4412 27.2064 38.5711 25.9153 38.5711C24.4501 38.5711 23.1533 38.3845 22.0268 38.0148C20.9004 37.6441 19.9404 37.116 19.1446 36.4321C18.3489 35.7461 17.797 35.0178 17.4901 34.2457C17.1828 33.4745 17.0301 32.3556 17.0301 30.8905V19.6435H13.4852V15.1053C14.7446 14.696 15.8252 14.1106 16.7224 13.3458C17.621 12.5822 18.3413 11.6645 18.8844 10.593C19.4284 9.52251 19.8027 8.15865 20.0071 6.50477V6.50468Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.c332004b914f0638c9e744d5b581b1fe.svg";
export { ForwardRef as ReactComponent };